export default __webpack_public_path__ + "static/media/bell.a907bc0d.svg";